import { CloseButtonProps, ToastContainer } from 'react-toastify'
import { cssTransition } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'animate.css'
import styled from 'styled-components'
import { Border, Colors, Shadows, Spacing, Typography } from '../../../styles'
import { OVERLAY_GUTTER, OVERLAY_MAX_WIDTH, safeArea } from '../../../styles/dimensions'
import { icons } from '../../../styles/images'
import { Icon } from '../Icon'
import NoStyleButton from '../buttons/NoStyleButton'

const ButtonMarginLeft = styled(NoStyleButton)`
    margin-left: ${Spacing._8};
`

const CloseButton = ({ closeToast, theme }: CloseButtonProps) => (
    <ButtonMarginLeft onClick={closeToast}>
        <Icon icon={icons.x} color={theme === 'light' ? 'black' : 'white'} />
    </ButtonMarginLeft>
)

const toastAnimation = cssTransition({
    enter: 'animate__animated animate__pulse',
    exit: 'animate__animated animate__fadeOutRight',
})

const StyledToastContainer = styled(ToastContainer).attrs({
    className: 'toast-container',
    toastClassName: 'toast',
    bodyClassName: 'toast-body',
    hideProgressBar: true,
    position: 'bottom-right',
    transition: toastAnimation,
    closeButton: CloseButton,
    newestOnTop: true,
})`
    --toastify-toast-width: min(400px, ${OVERLAY_MAX_WIDTH});
    --toastify-color-light: ${Colors.background.white};
    --toastify-color-dark: ${Colors.text.ink};
    --toastify-text-color-light: ${Colors.text.ink};
    --toastify-text-color-dark: ${Colors.text.white};
    .toast {
        border: ${Border.stroke.medium} solid ${Colors.background.border};
        box-shadow: ${Shadows.modal};
        border-radius: ${Border.radius.medium};
        cursor: auto;
    }
    .toast-body {
        position: relative;
        padding: 0;
        display: initial;
        font-family: ${Typography.fontFamily.sans};
        min-width: 0;
    }
    /* react-toastify ships its own <=480px rule that pins the container to 100vw with square
       corners. Keep the floating card instead; && outranks that single-class rule. */
    @media only screen and (max-width: 480px) {
        && {
            width: var(--toastify-toast-width);
            left: auto;
            right: ${OVERLAY_GUTTER};
            bottom: calc(${OVERLAY_GUTTER} + ${safeArea.bottom});
            padding: 0;
        }
        .toast {
            border-radius: ${Border.radius.medium};
            margin-bottom: ${Spacing._8};
        }
    }
`

export default StyledToastContainer
